export default "__VITE_ASSET__877ce8b7__"